import { useDispatch } from "react-redux";
import { setSurveyFormState } from "../../../features/surveySlice.js";

export default function CloseSurveyButton() {
    const dispatch = useDispatch();

    const handleCloseSurveyButton = () => {
        dispatch(setSurveyFormState(false));
    };

    return (
        <button id="close" onClick={ handleCloseSurveyButton }>
            <i className="fa fa-times fa-lg" aria-hidden="true"></i>
        </button>
    );
};
